"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientRender = clientRender;
exports.default = void 0;
exports.serverRender = serverRender;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));
var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));
var _decorators = require("decorators");
var _jQuery = babelHelpers.interopRequireDefault(require("jQuery"));
var _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { babelHelpers.defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let ServiceForm = exports.default = (_class = class ServiceForm extends _react.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      name: "",
      phone: "",
      email: "",
      property: "",
      address: "",
      comments: "",
      submitting: false,
      submitted: false,
      submittedOverlayInDocument: false
    };
  }
  nameChanged(event) {
    this.setState({
      name: event.target.value
    });
  }
  phoneChanged(event) {
    this.setState({
      phone: event.target.value
    });
  }
  emailChanged(event) {
    this.setState({
      email: event.target.value
    });
  }
  propertyChanged(event) {
    this.setState({
      property: event.target.value
    });
  }
  toggleComments() {
    (0, _jQuery.default)(this.commentsField).slideToggle();
  }
  commentsChanged(event) {
    this.setState({
      comments: event.target.value
    });
  }
  addressChanged(event) {
    this.setState({
      address: event.target.value
    });
  }
  gotCommentsField(ref) {
    this.commentsField = ref;
  }
  gotSubmittedOverlay(ref) {
    this.submittedOverlay = ref;
  }
  get formInvalid() {
    return !this.state.name || !this.state.phone || !this.state.email;
  }
  submitForm() {
    this.setState({
      submitting: true
    });
  }
  componentDidUpdate() {
    if (this.state.submitting && !this.state.submitted) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'data/service-request', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) this.setState({
          submitted: true
        });
      };
      xhr.send(JSON.stringify(_objectSpread({
        service: this.props.service.id,
        name: this.state.name,
        phone: this.state.phone,
        email: this.state.email,
        comments: this.state.comments
      }, this.props.service.seo_url == 'Pro-Site' ? {
        property: this.state.property
      } : {
        address: this.state.address
      })));
    }
    if (!this.state.submittedOverlayInDocument && this.submittedOverlay) {
      this.setState({
        submittedOverlayInDocument: true
      });
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `services-form form${this.props.service.seo_url == 'Pro-Site' ? ' prosite-form' : ''}`,
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Call", ' 503.906.' + (this.props.service.seo_url == 'Pro-Site' ? '8148 ' : '8118 '), " or contact us below"), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-field-container col-md-8 col-xs-12"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Name *",
      onChange: this.nameChanged,
      value: this.state.name
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Phone Number *",
      onChange: this.phoneChanged,
      value: this.state.phone
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Email Address *",
      onChange: this.emailChanged,
      value: this.state.email
    })), this.props.service.seo_url == 'Pro-Site' ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Property / Facility Name",
      onChange: this.propertyChanged,
      value: this.state.property
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("textarea", {
      rows: 3,
      className: "form-control",
      onChange: this.commentsChanged,
      placeholder: "Comments",
      value: this.state.comments
    }))) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("textarea", {
      rows: 3,
      className: "form-control",
      onChange: this.addressChanged,
      placeholder: "Address",
      value: this.state.address
    })), /*#__PURE__*/_react.default.createElement("a", {
      className: "add-comments-link",
      href: "javascript:void(0)",
      onClick: this.toggleComments
    }, "+ Add Comments"), /*#__PURE__*/_react.default.createElement("div", {
      ref: this.gotCommentsField,
      className: "form-group comments-field"
    }, /*#__PURE__*/_react.default.createElement("textarea", {
      rows: 3,
      className: "form-control",
      onChange: this.commentsChanged,
      value: this.state.comments
    })))), /*#__PURE__*/_react.default.createElement("button", {
      className: "btn submit-form-btn",
      disabled: this.formInvalid || this.state.submitting,
      onClick: this.submitForm
    }, "Send Request"), this.state.submitted ? /*#__PURE__*/_react.default.createElement("div", {
      ref: this.gotSubmittedOverlay,
      style: {
        position: 'absolute',
        background: '#ededed',
        opacity: this.state.submittedOverlayInDocument ? 1 : 0,
        transition: '.3s ease',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("h1", null, "Thank you for your submission!"), /*#__PURE__*/_react.default.createElement("p", null, "We will be in contact with you soon about ", this.props.service.title, ".")) : null);
  }
}, babelHelpers.applyDecoratedDescriptor(_class.prototype, "nameChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "nameChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "phoneChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "phoneChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "emailChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "emailChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "propertyChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "propertyChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "toggleComments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "toggleComments"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentsChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "commentsChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "addressChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "addressChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotCommentsField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotCommentsField"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotSubmittedOverlay", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotSubmittedOverlay"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitForm"), _class.prototype), _class);
function serverRender(service) {
  return `
		<div data-component='ServiceForm'>${_server.default.renderToString(/*#__PURE__*/_react.default.createElement(ServiceForm, {
    service: service
  }))}</div>
		<script>
			require('service-form').clientRender(${JSON.stringify(service)}, document.querySelector('[data-component=ServiceForm]'));
		</script>
	`;
}
function clientRender(service, node) {
  _reactDom.default.render(/*#__PURE__*/_react.default.createElement(ServiceForm, {
    service: service
  }), node);
}